import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

const BTN_NAV =
  "h-7 w-7 bg-slate-800 hover:bg-slate-700 rounded-lg flex items-center justify-center text-slate-400 hover:text-white transition-colors flex-shrink-0";

export function YearPicker({ calMonth, setCalMonth, setView, selectedDate }) {
  const curYear = calMonth.getFullYear();
  const pageStart = Math.floor(curYear / 12) * 12;
  const years = Array.from({ length: 12 }, (_, i) => pageStart + i);
  const today = new Date();
  return (
    <div className="p-3 w-[252px]">
      <div className="flex items-center justify-between mb-3 px-1">
        <button
          type="button"
          onClick={() => setCalMonth(new Date(curYear - 12, calMonth.getMonth(), 1))}
          className={BTN_NAV}
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <span className="text-sm font-semibold text-slate-300">
          {pageStart} – {pageStart + 11}
        </span>
        <button
          type="button"
          onClick={() => setCalMonth(new Date(curYear + 12, calMonth.getMonth(), 1))}
          className={BTN_NAV}
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
      <div className="grid grid-cols-3 gap-1.5">
        {years.map((year) => {
          const isSel = selectedDate && selectedDate.getFullYear() === year;
          const isTod = today.getFullYear() === year;
          return (
            <button
              key={year}
              type="button"
              onClick={() => {
                setCalMonth(new Date(year, calMonth.getMonth(), 1));
                setView("months");
              }}
              className={cn(
                "py-2 rounded-lg text-sm font-medium transition-all",
                isSel
                  ? "bg-altiv-navy text-white"
                  : isTod
                    ? "bg-slate-700 text-white"
                    : "text-slate-300 hover:bg-slate-700 hover:text-white"
              )}
            >
              {year}
            </button>
          );
        })}
      </div>
    </div>
  );
}
